import React from 'react';

/**
 * default mount to node id #toTopButton
 */
class ToTopButton extends React.PureComponent {
  widthHelperRef = React.createRef();

  state = {
    isVisible: false,
    containerWidth: 1134,
  };

  onScroll = () => {
    this.setState({ isVisible: window.scrollY > window.innerHeight / 3 });
  };

  componentDidMount() {
    window.addEventListener('scroll', this.onScroll);
    const newContainerWidth = this.widthHelperRef?.current.clientWidth ?? 1164;
    this.setState({ containerWidth: newContainerWidth });
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.onScroll);
  }

  render() {
    const { isVisible, containerWidth } = this.state;
    const containerClass = ['to-top-container'];
    if (isVisible) containerClass.push('to-top-container--visible');

    const margin = 20;
    const componentWidth =
      (document.body.offsetWidth - containerWidth) / 2 - margin*2;
    return (
      <React.Fragment>
        <div className="to-top-width-helper" ref={this.widthHelperRef} />
        <div
          className={containerClass.join(' ')}
          style={{
            width: componentWidth,
            marginRight: margin,
            marginLeft: margin,
            PointerEvent: isVisible ? 'visible' : 'none',
          }}
        >
          <a className="to-top" href="#">
            <div className="to-top__icon" />
            <span className="to-top__text">
              Наверх
            </span>
          </a>
        </div>
      </React.Fragment>
    );
  }
}

export default ToTopButton;
